import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from '../../caremap/CareMapState';
import { CareCodeModalState } from './CareCodeModalState';
import { CreateCareCodeModal } from './CreateCareCodeModal';

// Single app-level mount of the Care Code confirmation modal, opened from anywhere (the main
// menu, the care recipient menu) via the shared CareCodeModalState. Rendered only when a care
// map is active, since a Care Code is always for a specific care recipient.
export const GlobalCareCodeModal: FC = () => {
    const state = useInstance(CareCodeModalState);
    useSubscription(() => state);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    if (!careMapState.getActiveCaremap()) {
        return null;
    }

    return (
        <CreateCareCodeModal
            isOpen={state.isOpen}
            patientFirstName={careMapState.getPatientFirstName() || 'Your loved one'}
            trackingFrom={state.trackingFrom}
            closeHandler={state.close}
        />
    );
};
